import { render, staticRenderFns } from "./CostSideSheet.vue?vue&type=template&id=5cae87b6&scoped=true"
import script from "./CostSideSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./CostSideSheet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CostSideSheet.vue?vue&type=style&index=0&id=5cae87b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae87b6",
  null
  
)

export default component.exports